import React from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { Line } from 'react-chartjs-2';

const PlaybackMetrics = ({ chartLabels, playbackMetrics }) => {
    return (
        <Card className="mb-4">
            <CardBody>
                <CardTitle tag="h5" style={{ color: "#6691e7" }}>Playback Metrics</CardTitle>
                <hr />
                <Row>
                    <Col md={4} className="mb-3">
                        <div style={{ height: '200px' }}>
                            <Line
                                data={{
                                    labels: chartLabels,
                                    datasets: [{
                                        label: 'Bandwidth (Mbps)',
                                        data: playbackMetrics.bandwidth,
                                        borderColor: '#007bff',
                                        backgroundColor: 'rgba(0, 123, 255, 0.1)',
                                        borderWidth: 2,
                                        fill: false,
                                        tension: 0.1
                                    }]
                                }}
                                options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        title: {
                                            display: true,
                                            text: 'Bandwidth (Mbps)',
                                            font: {
                                                size: 14
                                            }
                                        }
                                    },
                                    scales: {
                                        y: {
                                            beginAtZero: true,
                                            title: {
                                                display: true,
                                                text: 'Mbps'
                                            }
                                        },
                                        x: {
                                            display: chartLabels.length > 0
                                        }
                                    }
                                }}
                            />
                        </div>
                    </Col>
                    <Col md={4} className="mb-3">
                        <div style={{ height: '200px' }}>
                            <Line
                                data={{
                                    labels: chartLabels,
                                    datasets: [{
                                        label: 'Current Bitrate (Mbps)',
                                        data: playbackMetrics.currentBitrate,
                                        borderColor: '#28a745',
                                        backgroundColor: 'rgba(40, 167, 69, 0.1)',
                                        borderWidth: 2,
                                        fill: false,
                                        tension: 0.1
                                    }]
                                }}
                                options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        title: {
                                            display: true,
                                            text: 'Current Bitrate (Mbps)',
                                            font: {
                                                size: 14
                                            }
                                        }
                                    },
                                    scales: {
                                        y: {
                                            beginAtZero: true,
                                            title: {
                                                display: true,
                                                text: 'Mbps'
                                            }
                                        },
                                        x: {
                                            display: chartLabels.length > 0
                                        }
                                    }
                                }}
                            />
                        </div>
                    </Col>
                    <Col md={4} className="mb-3">
                        <div style={{ height: '200px' }}>
                            <Line
                                data={{
                                    labels: chartLabels,
                                    datasets: [{
                                        label: 'Frame Rate (FPS)',
                                        data: playbackMetrics.frameRate,
                                        borderColor: '#dc3545',
                                        backgroundColor: 'rgba(220, 53, 69, 0.1)',
                                        borderWidth: 2,
                                        fill: false,
                                        tension: 0.1
                                    }]
                                }}
                                options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        title: {
                                            display: true,
                                            text: 'Frame Rate (FPS)',
                                            font: {
                                                size: 14
                                            }
                                        }
                                    },
                                    scales: {
                                        y: {
                                            beginAtZero: true,
                                            title: {
                                                display: true,
                                                text: 'FPS'
                                            }
                                        },
                                        x: {
                                            display: chartLabels.length > 0
                                        }
                                    }
                                }}
                            />
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default PlaybackMetrics;

